// this is a helper function to format the provided links correctly
// currently we receive this
// 124c71d524604ccbad6042edce3ac799/{'detail'|'navigation'|(...)}/{id}
import { useGetMedia } from '#imports';

export function useFormatCmsLink() {
    const { getSpecificMedia, getMedia } = useGetMedia();
    const { resolvePath } = useNavigationSearch();

    const getCmsLink = async (link: string | undefined) => {
        if (!link) {
            return null;
        }

        const pieces = link.split('/');
        // product route
        if (pieces[1] === 'detail') {
            try {
                //pieces[2] has an ending # that needs to be removed
                return await getProduct(pieces[2].substring(0, pieces[2].length - 1));
            } catch (error) {
                return null;
            }
        }

        // category route
        if (pieces[1] === 'navigation') {
            try {
                //pieces[2] has an ending # that needs to be removed
                return await getCategory(pieces[2].substring(0, pieces[2].length - 1));
            } catch (error) {
                return null;
            }
        }

        // media route
        if (pieces[1] === 'mediaId') {
            try {
                // remove the #
                const id = pieces[2].substring(0, pieces[2].length - 1);
                const { data: medias } = await getMedia([id]);
                return getSpecificMedia(id, medias.value)?.url;
            } catch (error) {
                return null;
            }
        }

        return link;
    };

    const getProduct = async (productId: string) => {
        const { data } = await useAsyncData(
            `product-seo-${productId}`,
            () => resolvePath(`/detail/${productId}`),
            {
                maxAge: 300, // 5 minutes in seconds
            }
        );
        return data.value?.seoPathInfo;
    };

    const getCategory = async (categoryId: string) => {
        const { data } = await useAsyncData(
            `category-seo-${categoryId}`,
            () => resolvePath(`/navigation/${categoryId}`),
            {
                maxAge: 300, // 5 minutes in seconds
            }
        );
        return data.value?.seoPathInfo;
    };



    return {
        getCmsLink,
    };
}
